import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js';
import { canCurrentUserAccessRoute, getSupervisorDefaultRoute } from '@/utils/accessControl';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'home',
                meta: {requiresAuth: true},
                component: () => import('../views/HomeView.vue'),
            },
        ],
    },
    {
        path: '/aide',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'help-center',
                meta: {requiresAuth: true},
                component: () => import('../views/HelpCenterView.vue'),
            },
        ],
    },
    {
        path: '/search',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'search',
                meta: {requiresAuth: true},
                component: () => import('../views/TicketSearch.vue'),
            },
        ],
    },
    {
        path: '/sales',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'sales',
                meta: {requiresAuth: true},
                component: () => import('../views/SalesReportView.vue'),
            },
        ],
    },
    {
        path: '/sales-summary',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'sales-summary',
                meta: {requiresAuth: true},
                component: () => import('../views/SalesSummaryReportView.vue'),
            },
        ],
    },
    {
        path: '/returns',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'returns',
                meta: {requiresAuth: true},
                component: () => import('../views/ReturnsReportView.vue'),
            },
        ],
    },
    {
        path: '/customers',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'customers',
                meta: {requiresAuth: true},
                component: () => import('../views/CustomersView.vue'),
            },
        ],
    },
    {
        path: '/customers/:id/statements',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'customer-statements',
                meta: {requiresAuth: true},
                component: () => import('../views/CustomerStatementsView.vue'),
            },
        ],
    },
    {
        path: '/customers/:id/statements/:statementId',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'statement-detail',
                meta: {requiresAuth: true},
                component: () => import('../views/StatementDetailView.vue'),
            },
        ],
    },
    {
        path: '/sales/:id',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'sale-details',
                meta: {requiresAuth: true},
                component: () => import('../views/SaleDetailsView.vue'),
            },
        ],
    },
    {
        path: '/agents',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'agents',
                meta: {requiresAuth: true},
                component: () => import('../views/AgentsReportView.vue'),
            },
        ],
    },
    {
        path: '/closing',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'closing',
                meta: {requiresAuth: true},
                component: () => import('../views/ClosingView.vue'),
            },
        ],
    },
    {
        path: '/rates',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'rates',
                meta: {requiresAuth: true},
                component: () => import('../views/RatesView.vue'),
            },
        ],
    },
    {
        path: '/productsreport',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'productsreport',
                meta: {requiresAuth: true},
                component: () => import('../views/ProductsReportView.vue'),
            },
        ],
    },
    {
        path: '/storesreport',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'storesreport',
                meta: {requiresAuth: true},
                component: () => import('../views/StoresReportView.vue'),
            },
        ],
    },
    {
        path: '/login',
        component: () => import('../components/Layouts/PublicLayout.vue'),
        meta: {guest: true},
        children: [
            {
                path: '',
                name: 'login',
                meta: {guest: true},
                component: () => import('../views/LoginView.vue'),
            },
        ],
    },
    {
        path: '/categories',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'categories',
                meta: {requiresAuth: true},
                component: () => import('../views/CategoriesView.vue'),
            },
        ],
    },
    {
        path: '/operations',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'operations',
                meta: {requiresAuth: true},
                component: () => import('../views/OperationsView.vue'),
            },
        ],
    },
    {
        path: '/stock',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'stock',
                meta: {requiresAuth: true},
                component: () => import('../views/StockView.vue'),
            },
        ],
    },
    {
        path: '/stock-movements',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'stock-movements',
                meta: {requiresAuth: true},
                component: () => import('../views/StockMovementView.vue'),
            },
        ],
    },
    {
        path: '/stock-alerts',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'stock-alerts',
                meta: {requiresAuth: true},
                component: () => import('../views/StockAlertView.vue'),
            },
        ],
    },
    {
        path: '/batches',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'batches',
                meta: {requiresAuth: true},
                component: () => import('../views/BatchReportView.vue'),
            },
        ],
    },
    {
        path: '/new-batche',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'new-batche',
                meta: {requiresAuth: true},
                component: () => import('../views/NewBatchView.vue'),
            },
        ],
    },
    {
        path: '/batches/:id',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'batch-details',
                meta: {requiresAuth: true},
                component: () => import('../views/BatchDetailsView.vue'),
            },
        ],
    },
    {
        path: '/klpay/settings',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'klpay/settings',
                meta: {requiresAuth: true},
                component: () => import('../views/KlPay/SettingsView.vue'),
            },
        ],
    },
    {
        path: '/payments/klpay',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'klpay/payments',
                meta: {requiresAuth: true},
                component: () => import('../views/KlPay/TransactionsView.vue'),
            },
        ],
    },
    {
        path: '/payments/natcash',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'natcash/payments',
                meta: {requiresAuth: true},
                component: () => import('../views/Natcash/PaymentReportView.vue'),
            },
        ],
    },
    {
        path: '/payments/moncash',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'moncash/payments',
                meta: {requiresAuth: true},
                component: () => import('../views/Moncash/PaymentReportView.vue'),
            },
        ],
    },
    {
        path: '/products',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'products',
                meta: {requiresAuth: true},
                component: () => import('../views/ProductsView.vue'),
            },
        ],
    },
    {
        path: '/catalog',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'catalog',
                meta: {requiresAuth: true},
                component: () => import('../views/CatalogView.vue'),
            },
        ],
    },
    {
        path: '/devices',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "devices",
                meta: {requiresAuth: true},
                component: () => import('../views/DeviceView.vue'),
            },
        ],
    },
    {
        path: '/account',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "account",
                meta: {requiresAuth: true},
                component: () => import('../views/AccountView.vue'),
            },
        ],
    },
    {
        path: '/natcash/balance',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "natcash/withdrawal-balance",
                meta: {requiresAuth: true},
                component: () => import('../views/Natcash/WithdrawlBalanceView.vue'),
            },
        ],
    },
    {
        path: '/natcash/withdrawal-requests',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "natcash/withdrawal-requests",
                meta: {requiresAuth: true},
                component: () => import('../views/Natcash/WithdrawalRequestView.vue'),
            },
        ],
    },
    {
        path: '/natcash/withdrawal-requests/:id',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "natcash/withdrawal-details",
                meta: {requiresAuth: true},
                component: () => import('../views/Natcash/WithdrawalRequestDetailView.vue'),
            },
        ],
    },
    {
        path: '/moncash/balance',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "withdrawal-balance",
                meta: {requiresAuth: true},
                component: () => import('../views/Moncash/WithdrawlBalanceView.vue'),
            },
        ],
    },
    {
        path: '/moncash/withdrawal-requests',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "withdrawal-requests",
                meta: {requiresAuth: true},
                component: () => import('../views/Moncash/WithdrawalRequestView.vue'),
            },
        ],
    },
    {
        path: '/moncash/withdrawal-requests/:id',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "withdrawal-detials",
                meta: {requiresAuth: true},
                component: () => import('../views/Moncash/WithdrawalRequestDetailView.vue'),
            },
        ],
    },
    {
        path: '/statement-settings',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'statement-settings',
                meta: {requiresAuth: true},
                component: () => import('../views/StatementSettingsView.vue'),
            },
        ],
    },
    {
        path: '/stores',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "stores",
                meta: {requiresAuth: true},
                component: () => import('../views/StoresView.vue'),
            },
        ],
    },
    {
        path: '/import',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: "import",
                meta: {requiresAuth: true},
                component: () => import('../views/ImportView.vue'),
            },
        ],
    },
    {
        path: '/loyverse/import',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'loyverse-import',
                meta: {requiresAuth: true},
                component: () => import('../views/LoyverseImportView.vue'),
            },
        ],
    },
    {
        path: '/users',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'users',
                meta: {requiresAuth: true},
                component: () => import('../views/UsersView.vue'),
            },
        ],
    },
    {
        path: '/restaurant/tables',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'restaurant-tables',
                meta: {requiresAuth: true},
                component: () => import('../views/TablesView.vue'),
            },
        ],
    },
    {
        path: '/restaurant/codes',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'supervisor-codes',
                meta: {requiresAuth: true},
                component: () => import('../views/SupervisorCodesView.vue'),
            },
        ],
    },
    {
        path: '/restaurant/tables/:id',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'table-detail',
                meta: {requiresAuth: true},
                component: () => import('../views/TableDetailView.vue'),
            },
        ],
    },
    {
        path: '/restaurant/servers',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'restaurant-servers',
                meta: {requiresAuth: true},
                component: () => import('../views/ServersView.vue'),
            },
        ],
    },
    {
        path: '/restaurant/orders',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'restaurant-orders',
                meta: {requiresAuth: true},
                component: () => import('../views/OrdersView.vue'),
            },
        ],
    },
    {
        path: '/restaurant/orders/:id',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'order-detail',
                meta: {requiresAuth: true},
                component: () => import('../views/OrderDetailView.vue'),
            },
        ],
    },
    {
        path: '/restaurant/commissions',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'restaurant-commissions',
                meta: {requiresAuth: true},
                component: () => import('../views/ServersReportView.vue'),
            },
        ],
    },
    {
        path: '/configurations',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'configurations',
                meta: {requiresAuth: true},
                component: () => import('../views/ConfigurationsView.vue'),
            },
        ],
    },
    {
        path: '/ingredients',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'ingredients',
                meta: {requiresAuth: true},
                component: () => import('../views/IngredientsView.vue'),
            },
        ],
    },
    {
        path: '/compositions',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'compositions',
                meta: {requiresAuth: true},
                component: () => import('../views/CompositionsView.vue'),
            },
        ],
    },
    {
        path: '/ingredient-stock',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'ingredient-stock',
                meta: {requiresAuth: true},
                component: () => import('../views/IngredientStockView.vue'),
            },
        ],
    },
    {
        path: '/ingredient-movements',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'ingredient-movements',
                meta: {requiresAuth: true},
                component: () => import('../views/IngredientStockMovementView.vue'),
            },
        ],
    },
    {
        path: '/ingredient-alerts',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'ingredient-alerts',
                meta: {requiresAuth: true},
                component: () => import('../views/IngredientStockAlertView.vue'),
            },
        ],
    },
    {
        path: '/ingredients-report',
        component: () => import('../components/Layouts/AppLayout.vue'),
        meta: {requiresAuth: true},
        children: [
            {
                path: '',
                name: 'ingredients-report',
                meta: {requiresAuth: true},
                component: () => import('../views/IngredientsReportView.vue'),
            },
        ],
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            if (!canCurrentUserAccessRoute(to.name)) {
                next(getSupervisorDefaultRoute())
                return
            }
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.guest)) {
        if (store.getters.isAuthenticated) {
            next(canCurrentUserAccessRoute("users") ? "/users" : getSupervisorDefaultRoute());
            return;
        }
        next();
    } else {
        next();
    }
});

export default router
